Vue.component("partner-system-assistant", {

    template: "#vue-partner-system-assistant",

    props: [
        "translations",
        "localizationData",
        "contact",
        "plentyId"
    ],

    computed: {
        ...Vuex.mapGetters(
            {
                trans: "getTranslation"
            }
        ),
        ...Vuex.mapState(
            {
                lang:                 state => state.localization.shopLanguage,
                pid:                  state => state.assistant.pid,
                contractsToSkip:      state => state.assistant.contractsToSkip,
                systemModuleList:     state => state.assistant.systemModuleList,
                contractModuleList:   state => state.assistant.contractModuleList,
                systemContractType:   state => state.assistant.systemContractType,
                assistantModuleList:  state => state.assistant.assistantModuleList,
                selectedContractType: state => state.assistant.selectedContractType
            }
        )
    },

    created()
    {
        this.$store.commit("setContractsToSkip", this.contractsToSkip.filter(contract => contract !== "partner"));

        this.$store.commit("setPid", this.plentyId);
        this.$store.commit("setContact", this.contact);
        this.$store.commit("setTranslation", this.translations);
        this.$store.commit("setLocalizationData", this.localizationData);
    },

    data()
    {
        return {
            waitForResponse: false
        };
    },

    ready()
    {
        this.getContractModuleList().then(() =>
        {
            this.$store.commit("setSelectedContractType", "partner");
            this.updateHostingId();

            this.navAction("next");
        });

    },

    methods: {
        ...Vuex.mapActions(
            [
                "getContract",
                "getContractList",
                "getContractModuleList"
            ]
        ),

        ...Vuex.mapMutations(
            [
                "setSelectedHostingId",
                "setAssistantModuleValue"
            ]
        ),

        onChangeAssistantModuleInput(module, event)
        {
            this.setAssistantModuleValue({
                module: module,
                value: event.target.valueAsNumber || event.target.value
            });
            this.updateHostingId();
        },

        updateHostingId()
        {
            this.setSelectedHostingId(
                this.contractModuleList.partner["hosting.type"][this.assistantModuleList.hosting.value].itemId
            );
        },

        /**
         * Page navigation of checkout
         * @param direction "next" or "prev"
         */
        navAction(direction)
        {
            const activeNode = document.getElementsByClassName("assistant-page show")[0];
            const nodeList = document.getElementsByClassName("assistant-page");

            let nodeIndex = activeNode.dataset.placement;

            if (direction === "prev")
            {
                nodeIndex--;
                this.currentPage--;
            }
            else if (direction === "next")
            {
                nodeIndex++;
                this.currentPage++;
            }

            document.getElementsByClassName("assistant-pages")[0].className =
                document.getElementsByClassName("assistant-pages")[0].className
                    .replace("page-" + activeNode.dataset.placement, "page-" + nodeIndex);

            activeNode.className = activeNode.className.replace(" show", "");
            nodeList[nodeIndex].className += " show";

            $("[data-toggle='tooltip']").tooltip();
        }
    }
});
